module.exports = __webpack_public_path__ + "static/media/plane(16).5932e17b.PNG";